import { useEffect, useState } from 'react';
import { Button } from '@chakra-ui/react';

import { Modal } from 'shared-components';
import { TravelStatusEnum } from 'types';

import { AdditionalQuestions } from './helpers/additional-questions/index';
import { ConfirmationBlock } from './helpers/confirmation-block';
import { IntroWrapper } from './helpers/intro-wrapper';
import { AdditionQuestionsEnum } from './helpers/types';
import { WhatIsYourTravelStatus } from './helpers/what-is-your-travel-status';

import { ITravelStatus } from '../../../../../../types';

interface IProps {
  onModalClose: () => void;
  saveTravelStatus: (data: ITravelStatus) => void;
  travelStatus: ITravelStatus;
}

export const TravelStatusModal = (props: IProps) => {
  const { onModalClose, saveTravelStatus, travelStatus } = props;

  const [selectedStatus, setSelectedStatus] = useState<TravelStatusEnum | AdditionQuestionsEnum | undefined>(undefined);

  const tStatus = travelStatus.status || TravelStatusEnum.None;

  const showConfirmationBlock = tStatus !== TravelStatusEnum.None;
  const [isQuestionAllowed, setIsQuestionAllowed] = useState(!showConfirmationBlock);

  const [additionalAnswers, setAdditionalAnswers] = useState<ITravelStatus>({});
  const [additionalQuestionsComplete, setAdditionalQuestionsComplete] = useState<boolean>(false);

  useEffect(() => {
    setAdditionalAnswers({});
    // eslint-disable-next-line
  }, [selectedStatus]);

  const saveTravelStatusHandler = () => {
    if (selectedStatus === AdditionQuestionsEnum.NewArrivedDate) {
      saveTravelStatus({
        ...additionalAnswers,
        status: TravelStatusEnum.Booked
      });
    } else {
      saveTravelStatus({ ...additionalAnswers, status: selectedStatus });
    }
    onModalClose();
  };

  return (
    <Modal
      id={'TravelStatusModal'}
      show={true}
      title={tStatus === TravelStatusEnum.None ? 'Set Your Current Travel Status' : 'Update Your Travel Status'}
      onClose={onModalClose}
      footer={
        <Button
          id="continue"
          isDisabled={!additionalQuestionsComplete}
          onClick={() => saveTravelStatusHandler()}
          variant="solid"
          size="lg"
        >
          Continue
        </Button>
      }
    >
      <IntroWrapper travelStatus={travelStatus} />

      {showConfirmationBlock && <ConfirmationBlock setConfirmation={setIsQuestionAllowed} />}

      {isQuestionAllowed && (
        <>
          <WhatIsYourTravelStatus
            travelStatus={travelStatus}
            selectedStatus={{
              status: selectedStatus,
              setStatus: setSelectedStatus
            }}
          />

          <AdditionalQuestions
            travelStatus={travelStatus}
            setComplete={setAdditionalQuestionsComplete}
            status={selectedStatus}
            additionalAnswers={{
              answers: additionalAnswers,
              setAnswers: setAdditionalAnswers
            }}
          />
        </>
      )}
    </Modal>
  );
};
